export default __webpack_public_path__ + "static/media/scissors.9c03b29a.png";